// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fs-10{font-size:10px}.fs-14{font-size:14px}.extras{line-height:130%!important}.bg-interrupt-yellow{background:#ffe9a4}.bg-interrupt-green{background:#438000}.text-interrupt-blue{color:#214e76}.text-interrupt-white{color:#fff}", ""]);
// Exports
module.exports = exports;
